<script setup lang="ts">
defineProps({
	title: {
		type: String,
		default: "Title"
	},
	description: {
		type: String,
		default: "Description"
	},
	closeButtonText: {
		type: String,
		default: "Cancel"
	},
	submitButtonText: {
		type: String,
		default: "Confirm"
	},
	submitButtonColor: {
		type: String,
		default: "rose",
		validator (v: string) {
			return ["violet", "rose", "emerald"].includes(v);
		}
	}
});
defineEmits(["submit", "close"]);

let bodyEl: HTMLElement;
let scrollBarWidth: number;
onMounted(() => {
	bodyEl = document.body;
	scrollBarWidth = window.innerWidth - bodyEl.clientWidth;
	bodyEl.style.marginRight = `${scrollBarWidth}px`;
	bodyEl.style.overflow = "hidden";
});
onUnmounted(() => {
	bodyEl.style.marginRight = "";
	bodyEl.style.overflow = "";
});
</script>

<template>
	<div
		class="fixed top-0 left-0 z-40 w-screen h-screen flex items-center justify-center bg-gray-900/40"
	>
		<div class="py-5 px-6 max-w-[480px] w-full bg-gray-0 rounded-sm">
			<span class="block font-semibold text-lg">
				{{ title }}
			</span>
			<span class="block mt-1 text-base text-gray-500">
				{{ description }}
			</span>
			<div class="mt-5 flex items-center justify-end gap-x-2">
				<AppButton @click="$emit('close')">
					{{ closeButtonText }}
				</AppButton>
				<AppButton
					type="submit"
					fill
					:color="submitButtonColor"
					@click="$emit('submit')"
				>
					{{ submitButtonText }}
				</AppButton>
			</div>
		</div>
	</div>
</template>
